import http from '@/utils/http'
import convert from '@/utils/model-convert'
import { SearchArgument } from '@/models/nature-pie'

// const URL = '/rest/customer/item/nature-pie'
const ITEM_URL = '/rest/customer/platform/items/all'
const URL = '/rest/customer/report/open-screen-analysis/wordKey'

export default {
  itemTitle ({search}, cb) {
    http.get(ITEM_URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  list ({search}, cb) {
    http.get(URL, {
      params: convert.toJson(search, SearchArgument)
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/nature-pie.js